import { Injectable } from '@angular/core';
import {AgendaItem} from "./room.service";
import {HttpClient} from "@angular/common/http";
import {map, Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {Page} from "./api.service";
import { Activity, ActivityResponse } from './activity.service';

export type Reward = 'OPT_IN' | 'ASSESSED_POOR' | 'ASSESSED_OK' | 'ASSESSED_GOOD' ;

export type RewardMap = { [key in Reward]: number ; }

export const DEFAULT_REWARDS: RewardMap = {
  'OPT_IN': 5,
  'ASSESSED_POOR': -5,
  'ASSESSED_OK': 5,
  'ASSESSED_GOOD': 10
}

export type TaskDecision = "OPT_IN" | "OPT_OUT" ;

export type Assessment = 'GOOD' | 'OK' | 'POOR' ;

export class VolunteerTask extends Activity {

  rewards: RewardMap ;
  recruiting: boolean ;
  bonus: boolean ;
  chosenUserId?: string ;
  chosenGroupId?: string ;
  assessment?: Assessment ;

  constructor (forGroups: boolean, bonus: boolean) {
    super('VOLUNTEER_TASK', forGroups) ;
    this.bonus = bonus ;
    this.recruiting = true ;
    this.rewards = DEFAULT_REWARDS ;
  }
}

export class VolunteerTaskAgendaItem extends AgendaItem {

  bonus: boolean ;
  rewards: RewardMap ;
  taskId?: string ;

  constructor(title: string, forGroups: boolean, bonus: boolean) {
    super('VOLUNTEER_TASK', forGroups, title) ;
    this.bonus = bonus ;
    this.rewards = DEFAULT_REWARDS ;
  }
}

export interface VolunteerTaskResponse extends ActivityResponse {
  
  decision: TaskDecision ;
  assessment: Assessment ;

}



@Injectable({
  providedIn: 'root'
})
export class VolunteerTaskService {

  constructor(
    private http: HttpClient
  ) {

  }

  getCurrent(roomId: string): Observable<VolunteerTask| undefined> {
      return this.http.get<Activity>(
        `${environment.apiHost}/rooms/${roomId}/activities/current`
      ).pipe(
        map( activity => {

          if (!activity || activity.type != 'VOLUNTEER_TASK') 
            return undefined ;
          else 
            return activity as VolunteerTask ;

        })
      );
    }

  start(roomId: string, task: VolunteerTask): Observable<VolunteerTask> {
    console.log("starting", task);
    return this.http.post<VolunteerTask>(
      `${environment.apiHost}/rooms/${roomId}/activities`,
      task
    ) ;
  }

  getResponses(taskId: string, page: number ): Observable<Page<VolunteerTaskResponse>> {

    let params = {
      page: (page) ? page : 0
    }

    return this.http.get<Page<VolunteerTaskResponse>>(
      `${environment.apiHost}/activities/${taskId}/responses`,
      {params}
    ) ;
  }

  getMyResponse(taskId: string): Observable<VolunteerTaskResponse> {

    return this.http.get<VolunteerTaskResponse>(
      `${environment.apiHost}/activities/${taskId}/responses/mine`,
    ) ;
  }

  updateMyResponse(taskId: string, decision: TaskDecision) {
    return this.http.patch<VolunteerTaskResponse>(
      `${environment.apiHost}/activities/${taskId}/responses/mine`,
      {
        type: 'VOLUNTEER_TASK',
        decision: decision
      }
    ) ;
  }

  findVolunteer(taskId: string): Observable<VolunteerTask> {

    return this.http.patch<VolunteerTask>(
      `${environment.apiHost}/activities/${taskId}`,
      {
        type: 'VOLUNTEER_TASK',
        recruiting: false
      }
    ) ;
  }

  assessVolunteer(taskId: string, assessment:Assessment): Observable<VolunteerTask> {

    return this.http.patch<VolunteerTask>(
      `${environment.apiHost}/activities/${taskId}`,
      {
        type: 'VOLUNTEER_TASK',
        assessment
      }
    ) ;
  }

  makeAdjustment(taskId: string, userOrGroupId: string, decision:TaskDecision | null, assessment: Assessment | null, explanation: string): Observable<VolunteerTaskResponse> {

    return this.http.post<VolunteerTaskResponse>(
      `${environment.apiHost}/activities/${taskId}/responses/${userOrGroupId}/adjustments`,
      {
        type: 'VOLUNTEER_TASK',
        decision,
        assessment,
        explanation
      }
    ) ;
  }

  cancel(taskId: string): Observable<VolunteerTask> {

    return this.http.delete(
      `${environment.apiHost}/activities/${taskId}`,
    ) as Observable<VolunteerTask>;
  }

  /*

  getKnowledgeEffects(task: VolunteerTask, attendee: Attendee): PointEffect[] {

    let knowledgePointsOffered = attendee.knowledgePointsOffered ;
    if (!task.bonus) {
      knowledgePointsOffered += (task.rewards['ASSESSED_GOOD'] - task.rewards['ASSESSED_POOR'])  ;
    }

    const effects: PointEffect[] = [] ;

    const goodDelta = (task.rewards['ASSESSED_GOOD'] - task.rewards['ASSESSED_POOR'])
    const good = (attendee.knowledgePointsEarned + goodDelta) / knowledgePointsOffered ;
    effects.push({
      points: Math.round((good - attendee.knowledgeScore) * 100 ),
      explanation: "for good feedback"
    })

    const okDelta = (task.rewards['ASSESSED_OK'] - task.rewards['ASSESSED_POOR'])
    const ok = (attendee.knowledgePointsEarned + okDelta) / knowledgePointsOffered ;
    effects.push({
      points: Math.round((ok - attendee.knowledgeScore) * 100 ),
      explanation: "for ok feedback"
    })

    const poor = (attendee.knowledgePointsEarned) / knowledgePointsOffered ;
    effects.push({
      points: Math.round((poor - attendee.knowledgeScore) * 100 ),
      explanation: "for poor feedback"
    })

    return effects ;
  }

  getParticipationEffects(task: VolunteerTask, attendee: Attendee): PointEffect[] {

    let participationPointsOffered = attendee.participationPointsOffered ;
    if (!task.bonus) {
      participationPointsOffered += task.rewards['OPT_IN']! ;
    }

    const effects: PointEffect[] = []

    const optIn = (attendee.participationPointsEarned + task.rewards['OPT_IN']) / participationPointsOffered ;
    effects.push({
      points: Math.round((optIn - attendee.participationScore) * 100 ),
      explanation: "for opting in"
    })

    const optOut = attendee.participationPointsEarned / participationPointsOffered ;
    effects.push({
      points: Math.round((optOut - attendee.participationScore) * 100 ),
      explanation: "for not opting in"
    })

    return effects ;
  }
    */

}
